'use client';

import { c as _c } from "react/compiler-runtime";
import { useMFE } from '@svenskaspelab/nova-core/nextjs/mfe';
import { type ComponentType, type ReactNode } from 'react';
import EmptyState from './OddsetQuickBetsEmptyState';
import QuickBetSkeleton from './OddsetQuickBetsSkeleton';
export type QuickBetsProps = {
  eventId: number;
  sportType: number;
  eventName: string;
  sticky?: boolean | 'indeterminate';
};

/**
 * Oddset component, renders Oddset Quickbets Component in SideNav.
 *
 * @param root0 Component props
 * @param root0.eventId - Kambi eventId (Number)
 * @param root0.sportType - Sport type (Number)
 * @param root0.eventName - Match description used in accessible odds link names
 * @param root0.sticky - Should oddset link be sticky (Boolean)
 * @returns QuickBets component
 */
export default function OddsetQuickBets(t0) {
  const $ = _c(9);
  const {
    eventId,
    sportType,
    eventName,
    sticky
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      name: "oddset",
      component: "QuickBets"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    Component: QuickBets,
    error,
    isLoading
  } = useMFE(t1) as {
    Component: ComponentType<QuickBetsProps> | null;
    error: Error | null;
    isLoading: boolean;
  };
  if (error) {
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = <EmptyState />;
      $[1] = t2;
    } else {
      t2 = $[1];
    }
    return t2;
  }
  if (isLoading) {
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = <div className="p-3"><QuickBetSkeleton /></div>;
      $[2] = t2;
    } else {
      t2 = $[2];
    }
    return t2;
  }
  let t2;
  if ($[3] !== QuickBets || $[4] !== eventId || $[5] !== eventName || $[6] !== sportType || $[7] !== sticky) {
    t2 = QuickBets && <div className="p-3"><QuickBets eventId={eventId} sportType={sportType} eventName={eventName} sticky={sticky} /></div> || undefined;
    $[3] = QuickBets;
    $[4] = eventId;
    $[5] = eventName;
    $[6] = sportType;
    $[7] = sticky;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  return t2;
}